const state = {
  qualifications: [],
};
export default state;
